import { TranslateLoader } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';
import { SpxTranslateEn } from "@softpak/components/spx-translate"
import { I18NText } from "./i18n-texts";

export class I18NLoader implements TranslateLoader {
    getTranslation(lang: string): Observable<any> {
      switch (lang) {
        default: return of({...SpxTranslateEn, ...I18NText.en });
      }
    }
}
